module.exports = __webpack_public_path__ + "img/h_s1e2_gallery_2.6bab55e6.png";